var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.2476 19.6154L15.6322 11.9999L23.2476 4.38448C24.2506 3.38154 24.2507 1.75538 23.2478 0.752306C22.2446 -0.250769 20.6184 -0.25064 19.6156 0.752306L12 8.36776L4.38442 0.752306C3.3816 -0.250769 1.75519 -0.250769 0.752241 0.752306C-0.250705 1.75538 -0.250704 3.38154 0.75237 4.38448L8.36782 11.9999L0.75237 19.6154C-0.250704 20.6185 -0.250833 22.2446 0.752241 23.2476C1.75557 24.2508 3.38173 24.2504 4.38442 23.2476L12 15.6321L19.6156 23.2476C20.6183 24.2505 22.2447 24.2506 23.2478 23.2476C24.2508 22.2445 24.2507 20.6183 23.2476 19.6154Z",
    fill: "#D9D9D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.419cd0ef74ae79a9c1241b8f061738ea.svg";
export { ForwardRef as ReactComponent };